export const FontFamily = {
  icons: 'Icons',
  readable: 'Roboto, sans-serif',
  regular: 'Geomanist, sans-serif',
}
